export const AppMain = {
  // THE SHEET IS FLAT (Nika 2026-09-24, Q2 (B)): it paints the SHEET pair
  // the app frame paints — gray2 dark / gray16 light, the pair app.js loads
  // into an app route's content element (`--stage-bg: light-dark(gray16,
  // gray2)`) — THE FRAME PAIR, written in three places: this file,
  // workspace/app.js and workspace/components/PageHeader.js, which move
  // together — so on an app route it never steps
  // off the frame, and only the cards and the rail on it step (CommonCard =
  // the brand `card`: 1.19:1 dark / 1.08:1 light). The sticky PageHeader
  // paints the same pair. On a canvas route (no content sheet there) it is
  // still a real sheet over the stage: 1.93:1 dark / 1.37:1 light on the
  // standard stage — the stage chain would have left its text on the bare
  // stage (a danger line read 4.20:1). It extended CommonCard and painted
  // `overlayStrong` / `white`: 1.00:1 dark and 1.04:1 light against the
  // frame, a second sheet no one could see that left every card on it flat.
  background: 'gray2',
  '@light': { background: 'gray16' },
  round: 'radiusCard',
  flow: 'y',
  flex: '1 1 0',
  minWidth: '0',
  minHeight: '0',
  overflow: 'hidden',
  margin: '- X2 X2 -',
  // No padding — AppMain is a container for Header + Body that each own
  // their inner spacing. (The CommonCard 'A' it once inherited inflated
  // panzoom canvas pages, and others, by 10px on every side.)
  padding: '0',

  '@mobileL': { margin: '0 X2 X2' },
  '@appMobile': { margin: '0 X2 X2' },

  Header: {
    flow: 'x',
    flex: '0 0 auto'
  },

  Body: {
    flex: '1 1 0',
    flow: 'y',
    minHeight: '0',
    minWidth: '0',
    overflow: 'hidden',
    position: 'relative'
  }
}
